import React, { Component, Fragment, useState } from "react";
import { translate } from "react-i18next";
import { request } from "./../../../../config";
import $ from "jquery";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import Loading from "./../../Loading/Loading";
import ReceiptModal from "./../../../../copms/Modal/ReceiptModalMpay";

class AllCategories extends Component {
  state = {
    isLoading: false,
    allCategories: [],
    selectedCategory: null,
    operations: {},
    pageNumber: 1,
    hasMore: true,
    isFetchingMore: false,
    receiptModalOpen: false,
    selectedTransaction: null,
    expandedCategory: null,
    isMobile: false,
  };

  componentDidMount() {
    this.getAllCategories();
    this.checkMobileMode();
    window.addEventListener("resize", this.checkMobileMode);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.checkMobileMode);
  }

  checkMobileMode = () => {
    const isMobile = window.innerWidth <= 768;
    if (this.state.isMobile !== isMobile) {
      this.setState({ isMobile });
    }
  };

  setSelectedCategory = (category) => {
    this.setState(
      {
        selectedCategory: category,
        operations: {},
        pageNumber: 1,
        hasMore: true,
      },
      () => {
        if (category) {
          this.getOperationsById();
        }
      },
    );
  };

  toggleCategoryExpand = (categoryId) => {
    const { expandedCategory } = this.state;
    const newExpandedCategory =
      expandedCategory === categoryId ? null : categoryId;

    this.setState(
      {
        expandedCategory: newExpandedCategory,
        selectedCategory: newExpandedCategory
          ? this.state.allCategories.find((c) => c.id === categoryId)
          : null,
        operations: {},
        pageNumber: 1,
        hasMore: true,
      },
      () => {
        if (newExpandedCategory) {
          this.getOperationsById();
        }
      },
    );
  };

  getAllCategories = () => {
    this.setState({ isLoading: true });

    let getCategoriesRequestBody = {
      token: localStorage.getItem("token"),
      accountId: this.props.accountId,
      lang: localStorage.getItem("i18nextLng").toUpperCase(),
    };

    fetch(request("account/expense-categories", getCategoriesRequestBody))
      .then((res) => res.text())
      .then(
        (getCategoriesResponseJSON) => {
          const JSON = require("true-json-bigint");
          let getCategoriesResponse = JSON.parse(getCategoriesResponseJSON);
          if (getCategoriesResponse.status.statusCode !== 1) {
            if (getCategoriesResponse.status.statusCode === 200) {
              this.props.logout();
            } else {
              this.setState({ isLoading: false });
            }
          } else {
            const allCategories = getCategoriesResponse.expenseCategories.map(
              (cat) => {
                const detailedCategory = this.props.detailedCategories?.find(
                  (dc) => dc.id === cat.categoryId,
                );
                return {
                  id: cat.categoryId,
                  categoryName: cat.categoryName,
                  colorHex: cat.colorHex,
                  icon: cat.icon,
                  amount: detailedCategory
                    ? detailedCategory.amountString
                    : "0 AZN",
                  percentage: detailedCategory
                    ? detailedCategory.percentage
                    : "0%",
                };
              },
            );

            this.setState({
              allCategories: allCategories,
              isLoading: false,
            });
          }
        },
        (error) => {
          this.props.history.push("/technical-break");
        },
      );
  };

  getOperationsById = (isLoadMore = false) => {
    const { pageNumber, operations } = this.state;

    this.setState({ isLoading: !isLoadMore, isFetchingMore: isLoadMore });

    let body = {
      token: localStorage.getItem("token"),
      accountId: this.props.accountId,
      lang: localStorage.getItem("i18nextLng").toUpperCase(),
      categoryId: this.state.selectedCategory.id,
      toDate: this.props.toDate,
      fromDate: this.props.fromDate,
      pageNumber: pageNumber,
      operationDirection: this.props.operationDirection,
    };

    fetch(request("account/operations", body))
      .then((res) => res.text())
      .then((jsonText) => {
        const JSON = require("true-json-bigint");
        let res = JSON.parse(jsonText);

        if (res.status.statusCode !== 1) {
          if (res.status.statusCode === 200) {
            this.props.logout();
          } else {
            this.setState({ isLoading: false, isFetchingMore: false });
          }
        } else {
          // const newOps = res.data.operations ?? [];
          const normalize = (d) => {
            const copy = new Date(d);
            copy.setHours(0, 0, 0, 0);
            return copy;
          };

          const newOps = (res.data.operations || []).reduce((acc, curr) => {
            const opsRawDate = curr.dataDate.split(".")[0];
            const opsDate = normalize(
              new Date(curr.dataDate.replace(" ", "T")),
            );

            const today = normalize(new Date());
            const isToday = today.getTime() === opsDate.getTime();

            const yesterday = new Date();
            yesterday.setDate(today.getDate() - 1);
            const isYesterday =
              normalize(yesterday).getTime() === opsDate.getTime();

            const isThisYear = today.getFullYear() === opsDate.getFullYear();

            // console.log(localStorage.getItem("i18nextLng"), "LANG");
            const localeLang =
              localStorage.getItem("i18nextLng") === "en"
                ? "en-US"
                : localStorage.getItem("i18nextLng") === "ru"
                  ? "ru-RU"
                  : localStorage.getItem("i18nextLng") === "az"
                    ? "az-AZ"
                    : "en-US";

            const months = {
              en: [
                "Jan",
                "Feb",
                "Mar",
                "Apr",
                "May",
                "Jun",
                "Jul",
                "Aug",
                "Sep",
                "Oct",
                "Nov",
                "Dec",
              ],
              ru: [
                "янв",
                "фев",
                "мар",
                "апр",
                "май",
                "июн",
                "июл",
                "авг",
                "сен",
                "окт",
                "ноя",
                "дек",
              ],
              az: [
                "Yan",
                "Fev",
                "Mar",
                "Apr",
                "May",
                "İyn",
                "İyl",
                "Avq",
                "Sen",
                "Okt",
                "Noy",
                "Dek",
              ],
            };

            const lang = localStorage.getItem("i18nextLng");
            const m =
              months[lang]?.[opsDate.getMonth()] ||
              months.en[opsDate.getMonth()];

            switch (true) {
              case isToday:
                if (!acc.today) {
                  acc.today = [];
                }
                acc.today.push(curr);
                break;
              case isYesterday:
                if (!acc.yesterday) {
                  acc.yesterday = [];
                }
                acc.yesterday.push(curr);
                break;
              case isThisYear:
                const monthDay = `${m} ${opsDate.getDate()}`;

                if (!acc[monthDay]) {
                  acc[monthDay] = [];
                }
                acc[monthDay].push(curr);
                break;
              case !isThisYear:
                const monthDayYear = `${m} ${opsDate.getDate()} ${opsDate.getFullYear()}`;

                if (!acc[monthDayYear]) {
                  acc[monthDayYear] = [];
                }
                acc[monthDayYear].push(curr);
                break;
              default:
                if (!acc.date) {
                  acc.date = [];
                }
                acc.date.push(curr);
            }

            return acc;
          }, this.state.operations);

          // console.log("Formatted Operations:", newOps);
          this.setState((prev) => ({
            // operations: isLoadMore ? { ...prev.operations, ...newOps } : newOps,
            operations: newOps,
            hasMore: pageNumber < res.data.totalPages,
            isLoading: false,
            isFetchingMore: false,
          }));
        }
      });
  };

  handleScroll = (e) => {
    const { scrollTop, scrollHeight, clientHeight } = e.target;
    const { hasMore, isFetchingMore } = this.state;

    if (
      scrollHeight - scrollTop <= clientHeight + 50 &&
      hasMore &&
      !isFetchingMore
    ) {
      this.setState(
        (prev) => ({ pageNumber: prev.pageNumber + 1 }),
        () => this.getOperationsById(true),
      );
    }
  };
  openReceiptModal = (operation) => {
    // Format transaction data for the modal
    const formattedTransaction = {
      ...operation,
      categoryName: this.state.selectedCategory.categoryName,
      organizedAmount: {
        wholePart: operation.amount.toString().split(".")[0] || "0",
        fractionalPart: operation.amount.toString().split(".")[1] || "00",
      },
      // organizedCardNumber: operation.crAccount,
      receiptNumber: operation.documentId,
      billingDate: operation.dataDate,
      // merchantName: operation.crAccount,
      crAccount: operation.crAccount,
      // billingStateId: operation.status === "Completed" ? 2 : operation.status === "Pending" ? 6 : 0,
      billingStateId: 2, // Assuming all transactions are completed for statistics
    };

    this.setState({
      receiptModalOpen: true,
      selectedTransaction: formattedTransaction,
    });
  };

  closeReceiptModal = () => {
    this.setState({
      receiptModalOpen: false,
      selectedTransaction: null,
    });
  };

  closeMobileCategory = () => {
    this.setState({
      expandedCategory: null,
      selectedCategory: null,
      operations: {},
    });
  };

  render() {
    const {
      allCategories,
      isLoading,
      selectedCategory,
      operations,
      receiptModalOpen,
      selectedTransaction,
      isMobile,
      expandedCategory,
    } = this.state;
    const { t } = this.props;

    return (
      <>
        <ReceiptModal
          history={this.props.history}
          item={null}
          secondDesc=""
          onClose={this.closeReceiptModal}
          data={selectedTransaction}
          open={receiptModalOpen}
          t={t}
        />
        <div
          className="dashboard-account-categories"
          style={isMobile ? { display: "flex", flexDirection: "column" } : {}}
        >
          {/* LEFT - CATEGORIES */}
          <div
            className={`dashboard-account-categories__list ${
              selectedCategory ? "single" : "grid"
            }`}
            style={
              isMobile
                ? {
                    width: "100%",
                    display: "flex",
                    flexDirection: "column",
                    paddingBottom: expandedCategory ? "0" : "20px",
                  }
                : {}
            }
          >
            {allCategories.map((cat) => (
              <div key={cat.id}>
                <div
                  className={`dashboard-account-category-item ${
                    selectedCategory?.id === cat.id ? "active" : ""
                  }`}
                  onClick={() => {
                    if (isMobile) {
                      this.toggleCategoryExpand(cat.id);
                    } else {
                      this.setSelectedCategory(cat);
                    }
                  }}
                  style={
                    isMobile
                      ? {
                          cursor: "pointer",
                          padding: "12px 16px",
                          borderRadius: "8px",
                          // marginBottom: "8px",
                          // backgroundColor: expandedCategory === cat.id ? "rgba(1, 121, 210, 0.08)" : "transparent",
                          border:
                            expandedCategory === cat.id
                              ? "1px solid #0179D2"
                              : "1px solid #E8EAED",
                          transition: "all 0.3s ease",
                        }
                      : {}
                  }
                >
                  <div
                    style={{
                      display: "flex",
                      gap: "24px",
                      width: "100%",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <div style={{ display: "flex", gap: "12px", flex: 1 }}>
                      <div
                        className="category-icon"
                        style={{ color: cat.colorHex, minWidth: "40px" }}
                        dangerouslySetInnerHTML={{
                          __html: atob(cat.icon),
                        }}
                      />
                      <div style={{ flex: 1, minWidth: 0 }}>
                        <div
                          className="dashboard-account-category-item-title"
                          style={isMobile ? { fontSize: "14px" } : {}}
                        >
                          {cat.categoryName}
                        </div>
                        <p
                          className="registration-container-description"
                          style={
                            isMobile
                              ? { fontSize: "12px", marginTop: "4px" }
                              : {}
                          }
                        >
                          {cat.percentage}
                        </p>
                      </div>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                        minWidth: "fit-content",
                      }}
                    >
                      <div
                        className="dashboard-account-category-item-amount"
                        style={isMobile ? { fontSize: "13px" } : {}}
                      >
                        {cat.amount}
                      </div>
                      <KeyboardArrowRightIcon
                        style={{
                          transform:
                            isMobile && expandedCategory === cat.id
                              ? "rotate(90deg)"
                              : "rotate(0deg)",
                          transition: "transform 0.3s ease",
                          color:
                            expandedCategory === cat.id ? "#0179D2" : "#AABDCF",
                        }}
                      />
                    </div>
                  </div>
                </div>

                {/* MOBILE - EXPANDED TRANSACTIONS */}
                {isMobile && expandedCategory === cat.id && (
                  <div
                    style={{
                      width: "100%",
                      borderRadius: "8px",
                      marginBottom: "16px",
                      backgroundColor: "#F8FAFB",
                      border: "1px solid #E8EAED",
                      overflow: "hidden",
                    }}
                  >
                    <div
                      style={{
                        padding: "12px 16px",
                        borderBottom: "1px solid #E8EAED",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <h5
                        style={{ margin: 0, fontSize: "14px", fontWeight: 600 }}
                      >
                        {cat.categoryName}
                      </h5>
                      <button
                        onClick={(e) => {
                          e.stopPropagation();
                          this.closeMobileCategory();
                        }}
                        style={{
                          background: "none",
                          border: "none",
                          cursor: "pointer",
                          fontSize: "18px",
                          color: "#2E3131",
                          padding: "0",
                        }}
                      >
                        ✕
                      </button>
                    </div>

                    <div
                      onScroll={this.handleScroll}
                      style={{
                        maxHeight: "calc(100vh - 300px)",
                        overflowY: "auto",
                        overscrollBehavior: "contain",
                      }}
                    >
                      {isLoading ? (
                        <div style={{ padding: "20px", textAlign: "center" }}>
                          <Loading />
                        </div>
                      ) : Object.keys(operations)?.length === 0 ? (
                        <div
                          style={{
                            textAlign: "center",
                            padding: "20px",
                            fontSize: "14px",
                            color: "#AABDCF",
                          }}
                        >
                          {t("No results found for the search")}
                        </div>
                      ) : (
                        Object.keys(operations).map((dateKey) => (
                          <Fragment key={dateKey}>
                            <div className="registration-container-description" style = {{paddingLeft: "12px"}}>
                              {dateKey}
                            </div>
                            {operations[dateKey].map((op) => (
                              <div
                                key={op.id}
                                className="dashboard-account-categories-transaction"
                                onClick={() => this.openReceiptModal(op)}
                                style={{
                                  cursor: "pointer",
                                  padding: "12px 16px",
                                  borderBottom: "1px solid #E8EAED",
                                  display: "flex",
                                  gap: "12px",
                                  alignItems: "flex-start",
                                }}
                              >
                                <div
                                  className="category-icon"
                                  style={{
                                    color: cat.colorHex,
                                    minWidth: "32px",
                                    marginTop: "4px",
                                  }}
                                  dangerouslySetInnerHTML={{
                                    __html: atob(cat.icon),
                                  }}
                                />
                                <div style={{ flex: 1, minWidth: 0 }}>
                                  <div
                                    className="tx-title"
                                    style={{
                                      fontSize: "13px",
                                      fontWeight: 500,
                                      marginBottom: "4px",
                                    }}
                                  >
                                    {op.purpose}
                                  </div>
                                  <div
                                    className="tx-sub"
                                    style={{
                                      fontSize: "11px",
                                      color: "#AABDCF",
                                      marginBottom: "4px",
                                    }}
                                  >
                                    {op.dataDate} • {op.crAccount}
                                  </div>
                                  <div
                                    className="tx-sub"
                                    style={{
                                      fontSize: "11px",
                                      color: "#AABDCF",
                                    }}
                                  >
                                    {t("Status")}: {op.status}
                                  </div>
                                </div>
                                <div
                                  style={{
                                    textAlign: "right",
                                    minWidth: "fit-content",
                                  }}
                                >
                                  <div
                                    className="tx-amount"
                                    style={{
                                      fontSize: "13px",
                                      fontWeight: 600,
                                    }}
                                  >
                                    {op.amount} {op.currency}
                                  </div>
                                </div>
                              </div>
                            ))}
                          </Fragment>
                        ))
                      )}

                      {this.state.isFetchingMore && (
                        <div style={{ textAlign: "center", padding: "12px" }}>
                          <Loading />
                        </div>
                      )}
                    </div>
                  </div>
                )}
              </div>
            ))}
          </div>

          {/* DESKTOP - RIGHT SIDE TRANSACTIONS */}
          {!isMobile && (
            <>
              {isLoading ? (
                <div
                  className="dashboard-container-main-section"
                  style={{ width: "50%" }}
                >
                  <Loading />
                </div>
              ) : (
                <>
                  {selectedCategory && (
                    <div className="dashboard-account-categories__details">
                      <div className="dashboard-account-categories-details-header">
                        <h5 className="dashboard-payment-container-data-section-content-title">
                          {selectedCategory.categoryName}
                        </h5>
                        <button
                          onClick={(e) => {
                            e.preventDefault();
                            this.setSelectedCategory(null);
                          }}
                        >
                          ✕
                        </button>
                      </div>
                      <div
                        className="dashboard-account-categories-transactions"
                        onScroll={this.handleScroll}
                        style={{ overflowY: "auto", maxHeight: "45rem" }}
                      >
                        {Object.keys(operations).length === 0 ? (
                          <div style={{ textAlign: "center", padding: 12 }}>
                            {t("No results found for the search")}
                          </div>
                        ) : (
                          Object.keys(operations).map((dateKey) => (
                            <Fragment key={dateKey}>
                              <div className="registration-container-description" style = {{paddingLeft: "12px"}}>
                                {dateKey}
                              </div>
                              {operations[dateKey].map((op) => (
                                <div
                                  key={op.id}
                                  className="dashboard-account-categories-transaction"
                                  onClick={() => this.openReceiptModal(op)}
                                  style={{ cursor: "pointer" }}
                                >
                                  <div
                                    className="category-icon"
                                    style={{ color: selectedCategory.colorHex }}
                                    dangerouslySetInnerHTML={{
                                      __html: atob(selectedCategory.icon),
                                    }}
                                  />
                                  <div>
                                    <div className="tx-title">{op.purpose}</div>
                                    <div className="tx-sub">
                                      {op.dataDate} {op.currency} {op.crAccount}
                                    </div>
                                  </div>
                                  <div>
                                    <div className="tx-sub">
                                      {t("Status")}: {op.status}
                                    </div>
                                    <div className="tx-amount">
                                      {op.amount} {op.currency}
                                    </div>
                                  </div>
                                </div>
                              ))}
                            </Fragment>
                          ))
                        )}

                        {this.state.isFetchingMore && (
                          <div style={{ textAlign: "center", padding: 12 }}>
                            <Loading />
                          </div>
                        )}
                      </div>
                    </div>
                  )}
                </>
              )}
            </>
          )}
        </div>
      </>
    );
  }
}
export default translate("translation")(AllCategories);
